import * as React from 'react';

import { theme } from '@notino/react-styleguide';

import { useVoucherDiscountContext } from '../context';
import { TextIcon } from '../styled';

import { IProductDiscountProps, ProductDiscount } from './ProductDiscount';
import {
  VoucherDiscountInfoWrapper,
  VoucherDiscountIconWrapper,
  VoucherDiscountInfoFlex,
  arrowClass,
} from './styled';

export interface IVoucherDiscountInfoProps extends IProductDiscountProps {
  showIcon: boolean;
  bottomSection?: React.ReactElement;
}

export const VoucherDiscountInfo: React.FC<IVoucherDiscountInfoProps> = ({
  showIcon,
  bottomSection,
  ...props
}) => {
  const { isUnderSelectBox, isArrowHidden, hasBlackFridayDiscount } =
    useVoucherDiscountContext();

  const iconBgColor = hasBlackFridayDiscount
    ? theme.color.background.inverse
    : theme.color.background.highlight;

  return (
    <VoucherDiscountInfoWrapper
      isUnderSelectBox={isUnderSelectBox}
      className={isArrowHidden ? '' : arrowClass}
    >
      <VoucherDiscountInfoFlex>
        <ProductDiscount {...props} columnOnMobile={showIcon} />
        {showIcon && (
          <VoucherDiscountIconWrapper data-testid="voucher-discount-icon">
            <TextIcon bgColor={iconBgColor}>Top!</TextIcon>
          </VoucherDiscountIconWrapper>
        )}
      </VoucherDiscountInfoFlex>

      {bottomSection}
    </VoucherDiscountInfoWrapper>
  );
};
